import { OfficialData } from "../networkRequest/officialsService";

/**
 * Check if a feature flag is enabled for an agency official
 * Checks both agency-specific flags and universal flags directly on the official object
 */
export const isFeatureFlagEnabled = (official: OfficialData | undefined, flagName: string): boolean => {
  if (!official) return false;
  // First check agency-specific flags
  const agencyFlag = official.feature_flags?.find(flag => flag.flag_name === flagName);
  if (agencyFlag) {
    return agencyFlag.enabled;
  }

  // Then check universal flags
  const universalFlag = official.universal_feature_flags?.find(flag => flag.flag_name === flagName);
  if (universalFlag) {
    return universalFlag.enabled;
  }

  // Flag not found, default to false
  return false;
};